module.exports = __webpack_public_path__ + "img/icon-css3.3cfcd1a8.svg";